import { Control } from 'ol/control';
import GIS from "../app";
import {GeolocationOptions} from "../configuration/control";

class GeolocationControl extends Control {
    private readonly button;
    private readonly GIS: GIS;

    constructor(GIS: GIS, options?: GeolocationOptions) {
        const element = document.createElement('div');

        super({
            element: element,
            target: options && options.target
        });

        this.GIS = GIS;

        this.changeAvailability = this.changeAvailability.bind(this);

        GIS.Geolocation.setOnStateChange(this.changeAvailability);

        this.button = document.createElement('button');

        element.className = 'cfm-geolocation ol-unselectable ol-control';
        element.appendChild(this.button);

        this.button.innerHTML = '<i class="fal fa-location"/>';
        this.GIS.Localisation.bindTitle(
            this.button,
            options?.i18n?.tip,
            options?.tip ?? 'Show location'
        );
        this.button.className = 'geolocation';
        this.button.type = 'button';

        this.button.addEventListener('click', () => this.handleGeolocate(), false);
    }

    private changeAvailability (availability: boolean) {
        if (availability) {
            this.button.innerHTML = '<i class="fal fa-location"/>';
        } else {
            this.button.innerHTML = '<i class="fal fa-location-slash"/>';
        }
    };

    private handleGeolocate () {
        if (this.GIS.Geolocation.getState()) {
            this.GIS.Layer.getGroupExtent('geolocation', (minx, miny, maxx, maxy) => {
                this.GIS.View.zoomToExtent([minx, miny, maxx, maxy])
            });
        } else {
            this.GIS.Geolocation.setTracking(true);
        }
    };
}

export default GeolocationControl;